import { useState, useEffect } from "react";
import NavbarItems from "./NavbarItems";
import { usePageContext } from "vike-react/usePageContext";

import "@/assets/style/navbar.scss";

export const NavbarDefault = ({
  scrolled,
  isHome,
}: {
  scrolled: boolean;
  isHome: boolean;
}) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const { urlPathname } = usePageContext();

  const shouldShowSubMenu =
    urlPathname === "/download" ||
    urlPathname === "/contact-us" ||
    urlPathname.startsWith("/travel-restrictions-and-travel-bans") ||
    urlPathname.startsWith("/clinics") ||
    urlPathname.startsWith("/clinic");

  useEffect(() => {
    setMenuOpen(false);
  }, [scrolled]);

  const shouldShowScrolled = !isHome || scrolled;

  const handleToggle = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className={`navbar navbar-expand-lg fixed-top${shouldShowScrolled ? " navbar-dark scrolled"
      : " navbar-light"}${isHome ? " home-page"
        : " inner-page"}`}>
      <div className="container">
        <a className="navbar-brand" href="/">
          <span className="fi-logo-horizontal navbar-logo" />
        </a>

        <button
          className="navbar-toggler"
          type="button"
          aria-controls="navbarNav"
          aria-expanded={menuOpen}
          aria-label="Toggle navigation"
          onClick={handleToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse${menuOpen ? " show" : ""}`} id="navbarNav">
          <NavbarItems type="main" />
        </div>
        {shouldShowSubMenu && (
          <>
            <div className="break navbar-collapse" id="navbarText" />
            <div className="collapse navbar-collapse justify-content-end" id="navbarText">
              <NavbarItems type="sub" />
            </div>
          </>
        )}
      </div>
    </nav>
  );
};
